import { Languages } from "lucide-react";
import { useTranslation } from "react-i18next";
import { supportedLanguages } from "../../i18n";
import { updatePreferredLanguageAPI } from "../../redux/api";
import "./LanguageSelector.css";

const LanguageSelector = ({ compact = false, className = "" }) => {
  const { i18n, t } = useTranslation();
  const current = supportedLanguages.find(({ code }) => code === i18n.resolvedLanguage) || supportedLanguages[0];

  const handleLanguageChange = async (event) => {
    const languageCode = event.target.value;
    await i18n.changeLanguage(languageCode);

    const session = JSON.parse(localStorage.getItem("admin_token_info") || "null");
    if (!session?.userId || !localStorage.getItem("Admin-API-Token")) return;

    try {
      const result = await updatePreferredLanguageAPI(languageCode);
      localStorage.setItem("admin_token_info", JSON.stringify({
        ...session,
        preferredLanguage: result.preferredLanguage || languageCode,
      }));
    } catch (error) {
      console.error("Could not sync preferred language:", error.message);
    }
  };

  return (
    <label className={`language-selector ${compact ? "language-selector--compact" : ""} ${className}`.trim()}>
      <Languages size={18} aria-hidden="true" />
      <span className="language-selector__label">{t("Language")}</span>
      <select
        aria-label={t("Language")}
        value={current.code}
        onChange={handleLanguageChange}
      >
        {supportedLanguages.map((language) => (
          <option key={language.code} value={language.code}>{language.nativeName}</option>
        ))}
      </select>
      {compact && <span className="language-selector__short" aria-hidden="true">{current.short}</span>}
    </label>
  );
};

export default LanguageSelector;
